import type { CalendarEventListItem } from "./types";

function instantOf(ev: CalendarEventListItem): number {
  if (ev.scheduled_at_utc) return new Date(ev.scheduled_at_utc).getTime();
  // All-day events have no time-of-day; anchor them at midnight UTC of
  // their date so they sort deterministically alongside timed events.
  return new Date(`${ev.scheduled_date}T00:00:00Z`).getTime();
}

/**
 * Choose which event the detail panel should default to when the visible
 * set changes (initial load, week navigation, filter change). Prefer the
 * first event strictly after `now`; if everything in view is past, fall
 * back to the latest event so the panel always has something to show.
 */
export function pickDefaultEventId(
  events: CalendarEventListItem[],
  now: Date,
): string | null {
  if (events.length === 0) return null;
  const nowMs = now.getTime();
  const sorted = [...events].sort((a, b) => instantOf(a) - instantOf(b));
  const next = sorted.find((ev) => instantOf(ev) > nowMs);
  if (next) return next.id;
  return sorted[sorted.length - 1].id;
}
